import { render, staticRenderFns } from "./Jumps.vue?vue&type=template&id=68726068&"
import script from "./Jumps.vue?vue&type=script&lang=js&"
export * from "./Jumps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68726068')) {
      api.createRecord('68726068', component.options)
    } else {
      api.reload('68726068', component.options)
    }
    module.hot.accept("./Jumps.vue?vue&type=template&id=68726068&", function () {
      api.rerender('68726068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/Jumps.vue"
export default component.exports